import { Roles } from "../../constants/roles";
import { SNSPreviewManagerSetup } from "./sns-preview-manager-setup";

class SNSPreviewApi {
    public static initForIndex(postSelector = `[data-role="${Roles.POST_CARD}"]`, createTiles = true): void {
        const manager = SNSPreviewManagerSetup.getManager();
        return manager.initForIndex(postSelector, createTiles);
    }

    public static initForDisplay(
        contentSelector = `[data-role="${Roles.POST_DETAIL_CONTENT}"]`,
        lightweightMode = false,
    ): void {
        const manager = SNSPreviewManagerSetup.getManager();
        return manager.initForDisplay(contentSelector, lightweightMode);
    }

    public static initForCreation(): void {
        const manager = SNSPreviewManagerSetup.getManager();
        manager.initializeForCreationPages();
    }
}

export { SNSPreviewApi };
